const getRequiredWordsLengthRule = (v, len) => {
  return (
    !v.length ||
    v.match(/\S+/g).length >= len ||
    `Please provide at least ${len} words describing the issue`
  )
} //getRequiredWordsLengthRule

const getMaxCharLengthRule = (v, len) => {
  return (
    !v.length || v.length <= len || `This field is limited to ${len} characters`
  )
} //getMaxCharLengthRule

export default {
  emailRule: (email) => {
    if (!email.trim()) return true

    var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return re.test(email) || 'Please enter a valid email'
  },
  required: (v) =>
    (v !== null && typeof v !== 'undefined') || 'This field is required',
  requiredString: (v) => !!v.trim() || 'This field is required',
  minWords10: (v) => getRequiredWordsLengthRule(v, 10),
  maxChars40: (v) => getMaxCharLengthRule(v, 40),
  userCodeLength: (v) => v.length === 5 || `The code must be 5 digits.`,
  phoneRule: (phone) => {
    if (!phone.trim()) return true

    if (phone.search(/^[a-zA-Z0-9-]+$/) === -1) {
      return 'Numbers and dashes only please. No spaces.'
    }

    let sanitizedPhone = phone.replace(/\D/g, '')
    if (!phone || !sanitizedPhone) return false

    if (sanitizedPhone[0] === '1') {
      return 'Enter a Valid 10 Digit Phone Number'
    }
    return sanitizedPhone.length === 10 || 'Enter a 10 Digit Phone'
  },
  urlRule: (v) => {
    if (!v.trim()) return true

    var pattern = new RegExp(
      '^(https?:\\/\\/)?' + // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~$+]*)*' + // port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
        '(\\#[-a-z\\d_]*)?$',
      'i'
    ) // fragment locator
    return (
      !!pattern.test(v) ||
      'Enter a valid web address starting with http:// or https://'
    )
  },
  venmoDeepLinkRuleiOS: (v) => {
    if (!v.trim()) return true

    // I think the Venmo ID is 8 digits long but unsure
    // so I'm specifying 6 or more digits in the Venmo ID part of the Regex
    var pattern = new RegExp('^(venmo?:\\/\\/)?(users\\/)(\\d{6,})', 'i')
    return (
      !!pattern.test(v) ||
      `Must be formatted like "venmo://users/XXXXXX" where the X's are your user ID`
    )
  }, // venmoDeepLinkRuleiOS
  zipRule: (v) => {
    return (!!v && v.length === 5) || 'Enter a 5 Digit Zip'
  },

  // Numbers stuff
  requiredNumeric: (v) => !!v || 'This field is required',
  unsignedNumberRule: (v) => {
    if (!v) return true
    else return Number(v) >= 0
  },
  greaterThanZero: (v) => {
    if (!v) return true
    else return Number(v) > 0
  },
}
